var _g, _path, _path2, _path3, _path4, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMortgageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9095_22557)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF738D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2024 22.4377L18.2408 20.0002C18.1808 19.8483 18.0407 19.75 17.8853 19.75H15.9621C15.8068 19.75 15.6667 19.8483 15.6067 20.0002L14.6451 22.4377C14.5959 22.5629 14.609 22.7059 14.6805 22.8188C14.7521 22.9326 14.8721 23 15.0005 23H18.8469C18.9754 23 19.0954 22.9326 19.167 22.8188C19.2385 22.7059 19.2516 22.5629 19.2024 22.4377Z",
    fill: "#FFEBF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2789 22.4377L21.3196 20.0002C21.2596 19.8491 21.1196 19.75 20.9642 19.75H19.0356C18.9241 19.75 18.8218 19.802 18.7502 19.8865L19.6741 22.2297C19.7726 22.4808 19.758 22.7587 19.6488 23H21.9235C22.052 23 22.172 22.9326 22.2435 22.8188C22.3151 22.7067 22.3282 22.5629 22.2789 22.4377Z",
    fill: "#FFEBF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7403 18.6456L19.7787 16.2081C19.7187 16.0562 19.5787 15.9579 19.4233 15.9579H17.5001C17.3447 15.9579 17.2047 16.0562 17.1447 16.2081L16.1831 18.6456C16.1339 18.7708 16.1469 18.9138 16.2185 19.0267C16.29 19.1396 16.41 19.2079 16.5385 19.2079H20.3849C20.5134 19.2079 20.6334 19.1404 20.7049 19.0267C20.7765 18.9138 20.7896 18.7716 20.7403 18.6456Z",
    fill: "#FFEBF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5607 12.4375H16.6718L17.5588 11.6876C17.8611 11.4332 17.9734 11.0197 17.8457 10.6337C17.7188 10.2494 17.3864 10 17.001 10H12.2315C11.8461 10 11.5137 10.2494 11.386 10.6346C11.2583 11.0197 11.3707 11.4332 11.673 11.6876L12.5607 12.4375Z",
    fill: "#FFEBF6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9349 22.1261L14.8965 19.6878C15.0019 19.4205 15.1942 19.219 15.4257 19.0898C15.368 18.8412 15.3773 18.578 15.4734 18.335L16.435 15.8967C16.615 15.4409 17.0328 15.1468 17.5005 15.1468H18.0774C17.6936 14.4245 17.2389 13.7663 16.7412 13.2512H12.4902C11.0893 14.7023 10 17.2495 10 19.3433C10 21.1633 10.9116 22.9996 12.9487 22.9996H13.9118C13.8179 22.7184 13.8233 22.4073 13.9349 22.1261Z",
    fill: "#FFEBF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9095_22557",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9095_22557"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortgageIcon);
export default __webpack_public_path__ + "static/media/mortgage_icon.60f56957e50897b543ba2af3c7feeccc.svg";
export { ForwardRef as ReactComponent };